export * as equipBuilding from './equip-building'
export * as equipCampus from './equip-campus'
export * as equipDepartmental from './equip-departmental'
export * as equipRoom from './equip-room'
export * as gaAcademic from './ga-academic'
export * as gaUniversityWide from './ga-university-wide'
export * as omDepartmental from './om-departmental'
export * as omEnvironmentHealthAndSafety from './om-environment-health-and-safety'
export * as omUniversityWide from './om-university-wide'
